'use client'

import { usePostHog } from '@posthog/next'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

import { PLUS_POSTHOG_EVENTS, PLUS_PRICING_SECTION_ID } from '@/app/[locale]/plus/constants'
import AnchorLink from '@/components/AnchorLink'
import ViverseButton from '@/components/ViverseButton'
import { DEFAULT_VIVERSE_ORIGIN } from '@/constants/domain'
import { useAuthContext } from '@/context/AuthContext'

export default function PlusConversionSection() {
  const t = useTranslations()
  const { isGamePlus } = useAuthContext()
  const posthog = usePostHog()

  return (
    <section className="px-6 pb-20 sm:px-8 sm:pb-0">
      <motion.div
        className="mx-auto mb-6 max-w-[1194px] overflow-hidden rounded-3xl bg-[linear-gradient(90deg,rgba(73,1,145,0.35)_0%,rgba(33,87,177,0.32)_52.404%,rgba(0,160,203,0.07)_100%)] px-6 py-14 sm:mb-20 sm:px-20 sm:py-20"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="mx-auto flex max-w-[704px] flex-col items-center text-center">
          <p className="text-vive-primary-40 text-xs leading-4 font-extrabold tracking-[6.15px] uppercase">
            {t('plus.conversion.cta.eyebrow')}
          </p>
          <h2 className="mt-5 text-3xl leading-10 font-extrabold tracking-[0.15px] text-[#eeeef0] sm:text-[38px]">
            {t('plus.conversion.cta.title')}
          </h2>
          <p className="text-vive-primary-30 mt-4 text-[15px] leading-[26px]">
            {t('plus.conversion.cta.description')}
          </p>
          <AnchorLink
            href={`#${PLUS_PRICING_SECTION_ID}`}
            onClick={() => posthog?.capture(PLUS_POSTHOG_EVENTS.VIEW_PLANS, { position: 'bottom' })}
          >
            <ViverseButton
              size="medium"
              variant="colorful"
              className="mt-8 min-h-12 w-full max-w-sm text-[18px]"
            >
              {isGamePlus ? t('plus.cta.manage-subscription') : t('plus.conversion.cta.button')}
            </ViverseButton>
          </AnchorLink>
          <p className="text-vive-primary-40 mt-7 text-[11px] leading-[18px]">
            {t.rich('plus.conversion.cta.subscription.terms', {
              terms: (chunks) => (
                <a
                  href={`${DEFAULT_VIVERSE_ORIGIN}/terms-of-use`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-vive-primary-40 hover:text-vive-primary-30 focus-visible:outline-vive-border-focus underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2"
                >
                  {chunks}
                </a>
              ),
            })}
          </p>
        </div>
      </motion.div>
    </section>
  )
}
